'use client';

import RelatedProducts from '@/components/RelatedProducts';
import { websiteEnv } from '@/constants/website-env';
import { useIsMobileSsr } from '@/hooks/use-is-mobile-ssr';
import { GET_PRODUCT_RELATED_PRODUCTS } from '@/typed-graphql/query';
import { gql, useQuery } from '@apollo/client';
import clsx from 'clsx';

const SuggestedProducts = props => {
  const {
    urlKey,
    upsellProducts,
    relatedProductFilterColor,
    defaultRelatedProductSlider,
    relatedProductsDefaultFilterColor,
  } = props;
  const { isMobile } = useIsMobileSsr();

  const { data: relatedProductsRes } = useQuery(gql(GET_PRODUCT_RELATED_PRODUCTS), {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      urlKey,
      filter_color: relatedProductFilterColor || '',
    },
    skip: relatedProductFilterColor === relatedProductsDefaultFilterColor,
  });
  const relatedProducts = relatedProductsRes?.products?.items?.[0]?.related_products || [];

  const relatedProductSlider =
    relatedProductFilterColor === relatedProductsDefaultFilterColor ? (
      defaultRelatedProductSlider
    ) : relatedProducts.length > 0 ? (
      <RelatedProducts
        products={relatedProducts}
        classNames={{
          carousel: clsx('px-2.5 lg_px-0'),
          carouselContent: clsx('flex -ml-4'),
          carouselItem: clsx('basis-1/2 lg_basis-[243px] pl-4'),
          carouselPrevArrow: clsx('top-[146px]'),
          carouselNextArrow: clsx('top-[146px]'),
        }}
      />
    ) : null;

  return (
    <div>
      {isMobile && websiteEnv.isUnitedStates && upsellProducts.length ? (
        <div className='mt-2.5 bg-white pb-[15px] pt-5 lg_mt-20 lg_hidden lg_p-0'>
          <div className='mx-auto max-w-site px-2.5 text-[17px]  leading-[22px] lg_px-0 lg_text-2xl lg_leading-7'>
            FINISH YOUR LOOK
          </div>
          <div className='mt-5'>
            <RelatedProducts
              products={upsellProducts}
              classNames={{
                carousel: 'px-2.5',
                carouselContent: clsx('flex -ml-4'),
                carouselItem: clsx('basis-1/2 pl-4'),
              }}
            />
          </div>
        </div>
      ) : null}
      {relatedProductSlider ? (
        <div className='mt-2.5 bg-white  pb-[15px] pt-5 lg_mt-20 lg_p-0 '>
          <h2 className='mx-auto max-w-site px-2.5 text-[17px] leading-[22px] lg_px-0 lg_text-2xl lg_leading-7'>
            YOU MAY ALSO LIKE
          </h2>
          <div className='mx-auto mt-5 max-w-site'>{relatedProductSlider}</div>
        </div>
      ) : null}
    </div>
  );
};

export default SuggestedProducts;
